import { DestinationType } from "_interfaces";
import { API_ENDPOINT } from "_lib/utils";
import axios from "axios";
import { atom, selector } from "recoil";

const DestinationSelector = selector<DestinationType[]>({
  key: "DestinationSelector",
  get: async ({ get }) => {
    try {
      const res = await axios.get(
        `${API_ENDPOINT}/items/destinations?sort=name`
      );
      const data: DestinationType[] = res.data.data.map((d: any) => {
        return {
          name: d.name,
          image: `${API_ENDPOINT}/assets/${d.image}/${d.name}.jpg`,
          slug: d.slug,
          starting_price: d.starting_price,
        };
      });
      return data;
    } catch (error) {
      console.error(error);
      return [] as DestinationType[];
    }
  },
});

const DestinationAtom = atom<DestinationType[]>({
  key: "DestinationAtom",
  default: DestinationSelector,
});

export { DestinationAtom };
